import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api.js'

// Личные единицы пользователя: порции продуктов и выбранные размеры
// встроенных единиц (яйцо, банан). Список короткий и грузится один раз;
// после каждой правки обновляется тем, что вернул сервер.
export const useUnitsStore = defineStore('units', () => {
  const rows = ref([])
  const loaded = ref(false)
  let loading = null

  const byProduct = computed(() => {
    const m = new Map()
    for (const r of rows.value) if (r.product_id) m.set(Number(r.product_id), r)
    return m
  })
  const byKey = computed(() => {
    const m = new Map()
    for (const r of rows.value) if (r.builtin_key) m.set(r.builtin_key, r)
    return m
  })
  // То, что принимает unitFor() из utils/units.js
  const personal = computed(() => ({ byProduct: byProduct.value, byKey: byKey.value }))

  async function load(force = false) {
    if (loaded.value && !force) return
    if (loading) return loading
    loading = api.get('/diary/units')
      .then(({ data }) => { rows.value = data.units || []; loaded.value = true })
      .catch(() => {})
      .finally(() => { loading = null })
    return loading
  }

  function upsertLocal(row) {
    const i = rows.value.findIndex(r => r.id === row.id
      || (row.product_id && r.product_id === row.product_id)
      || (row.builtin_key && r.builtin_key === row.builtin_key))
    if (i >= 0) rows.value.splice(i, 1, row); else rows.value.push(row)
  }

  async function setProductUnit(productId, unitName, grams) {
    const { data } = await api.put('/diary/units', { product_id: productId, unit_name: unitName, grams })
    upsertLocal(data.unit)
    return data.unit
  }

  async function setBuiltinSize(key, sizeCode, grams, unitName = 'шт') {
    const { data } = await api.put('/diary/units', { builtin_key: key, size_code: sizeCode, grams, unit_name: unitName })
    upsertLocal(data.unit)
    return data.unit
  }

  async function removeUnit(id) {
    await api.delete(`/diary/units/${id}`)
    rows.value = rows.value.filter(r => r.id !== id)
  }

  return { rows, loaded, personal, byProduct, byKey, load, setProductUnit, setBuiltinSize, removeUnit }
})
